import { z } from "zod";

export const AssetDynamoRecord = z.object({
  path: z.string(),
  id: z.string(),
  designSystemId: z.string(),
  expiresAt: z.number(),
});

export type AssetDynamoRecord = z.infer<typeof AssetDynamoRecord>;
